(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws-api.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws-api.js');

'use strict';

const drawsSingleton = svs.numbergames.draws.internal.getDrawsSingleton();
const {
  DRAW_STATES
} = svs.numbergames.draws.constants;
function clientNow() {
  return drawsSingleton.clientNow;
}
svs.numbergames.draws.drawsApi.clientNow = clientNow;
const firstPlayableDrawsApi = {
  firstPlayableDraw: draw => draw,
  isDrawOpen: draw => (draw === null || draw === void 0 ? void 0 : draw.drawStateId) === DRAW_STATES.OPEN,
  drawNumber: draw => draw === null || draw === void 0 ? void 0 : draw.drawNumber,
  regOpenTime: draw => draw === null || draw === void 0 ? void 0 : draw.regOpenTime,
  regCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.regCloseTime,
  cancelCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.cancelCloseTime,
  wasOpenedToday: draw => draw && dateFns.isSameDay(clientNow(), new Date(draw.regOpenTime)),
  roomKeys: draw => draw === null || draw === void 0 ? void 0 : draw.roomKeys,
  isJokerDrawOpen: draw => {
    var _draw$jokerDraw;
    return (draw === null || draw === void 0 || (_draw$jokerDraw = draw.jokerDraw) === null || _draw$jokerDraw === void 0 ? void 0 : _draw$jokerDraw.drawStateId) === DRAW_STATES.OPEN;
  },
  hasPlayableJoker: draw => {
    var _draw$jokerDraw2;
    return (draw === null || draw === void 0 || (_draw$jokerDraw2 = draw.jokerDraw) === null || _draw$jokerDraw2 === void 0 ? void 0 : _draw$jokerDraw2.drawStateId) <= DRAW_STATES.OPEN;
  },
  jokerDrawNumber: draw => {
    var _draw$jokerDraw3;
    return draw === null || draw === void 0 || (_draw$jokerDraw3 = draw.jokerDraw) === null || _draw$jokerDraw3 === void 0 ? void 0 : _draw$jokerDraw3.drawNumber;
  },
  jokerRegOpenTime: draw => {
    var _draw$jokerDraw4;
    return draw === null || draw === void 0 || (_draw$jokerDraw4 = draw.jokerDraw) === null || _draw$jokerDraw4 === void 0 ? void 0 : _draw$jokerDraw4.regOpenTime;
  },
  jokerRegCloseTime: draw => {
    var _draw$jokerDraw5;
    return draw === null || draw === void 0 || (_draw$jokerDraw5 = draw.jokerDraw) === null || _draw$jokerDraw5 === void 0 ? void 0 : _draw$jokerDraw5.regCloseTime;
  }
};
const nextDrawsApi = {
  nextDraw: draw => draw,
  nextRegOpenTime: draw => draw === null || draw === void 0 ? void 0 : draw.regOpenTime,
  nextRegCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.regCloseTime
};
function formatDraws(draws, getValue, products) {
  draws = Object.values(draws).filter(Boolean);
  if (!Array.isArray(products) && draws.length === 1) {
    return getValue(draws[0]);
  }
  return draws.reduce((acc, draw) => Object.assign(acc, {
    [draw.productItsId]: getValue(draw)
  }), {});
}
Object.entries(firstPlayableDrawsApi).forEach(_ref => {
  let [key, value] = _ref;
  svs.numbergames.draws.drawsApi[key] = products => formatDraws(drawsSingleton.findFirstPlayableDraw(products), value, products);
  svs.numbergames.draws.asyncDrawsApi[key] = async products => formatDraws(await drawsSingleton.getFirstPlayableDraw(products), value, products);
});
Object.entries(nextDrawsApi).forEach(_ref2 => {
  let [key, value] = _ref2;
  svs.numbergames.draws.drawsApi[key] = products => formatDraws(drawsSingleton.findNextDraw(products), value, products);
  svs.numbergames.draws.asyncDrawsApi[key] = async products => formatDraws(await drawsSingleton.getNextDraw(products), value, products);
});

 })(window);